import React from 'react';
import StreamerAdminTable from './streamer-admin.table';

function StreamerAdminHome(props) {
  return <StreamerAdminTable {...props} />;
}

export default StreamerAdminHome;
